// src/components/forum/FollowButton.jsx
import React, { useState, useEffect } from 'react';
import { Star } from 'lucide-react';
import { threadFollowService } from '../../Services/threadFollowService';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';

const FollowButton = ({ threadId, className = '' }) => {
  const { user } = useAuth();
  const [isFollowing, setIsFollowing] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkFollowStatus();
  }, [user, threadId]);

  const checkFollowStatus = async () => {
    if (!user?.uid || !threadId) return;

    try {
      const following = await threadFollowService.isFollowing(user.uid, threadId);
      setIsFollowing(following);
    } catch (error) {
      console.error('Erreur vérification suivi:', error);
    }
  };

  const handleToggleFollow = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!user?.uid) {
      toast.error('Connectez-vous pour suivre ce sujet');
      return;
    }

    setLoading(true);
    try {
      if (isFollowing) {
        await threadFollowService.unfollowThread(user.uid, threadId);
        setIsFollowing(false);
        toast.success('Sujet retiré de vos suivis');
      } else {
        await threadFollowService.followThread(user.uid, threadId);
        setIsFollowing(true);
        toast.success('Vous suivez maintenant ce sujet');
      }
    } catch (error) {
      console.error('Erreur toggle suivi:', error);
      toast.error('Erreur lors du suivi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleToggleFollow}
      disabled={loading}
      className={`
        flex items-center gap-2 px-3 py-1.5 rounded-lg
        transition-all duration-200
        ${
          isFollowing
            ? 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 hover:bg-yellow-200 dark:hover:bg-yellow-900/50'
            : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'
        }
        disabled:opacity-50 disabled:cursor-not-allowed
        ${className}
      `}
      title={isFollowing ? 'Ne plus suivre' : 'Suivre ce sujet'}
    >
      <Star
        className={`w-4 h-4 transition-all ${isFollowing ? 'fill-yellow-500 text-yellow-500' : ''}`}
      />
      <span className="text-sm font-medium">{isFollowing ? 'Suivi' : 'Suivre'}</span>
    </button>
  );
};

export default FollowButton;
